import React, { useEffect } from 'react';
import { Field } from 'redux-form';
import { required } from 'redux-form-validators';
import { cloneDeep } from 'lodash';
import InputField from '../../../../../../../../helpers/Fields/InputField';


import s from './style.module.scss';

function AnswerType5({ answers, rootChange, formatMessage }) {
  useEffect(() => {
    let variants = cloneDeep(answers.variants || []);
    if (answers.value && variants) {
      const count = (answers.value.match(/___/g) || []).length;
      if (count != variants.length) {
        if (variants.length < count) {
          for (let index = 0; index < count; index++) {
            if (variants.length - 1 < index) {
              variants.push('');
            }
          }
        } else {
          variants = variants.filter((i, index) => index < count - 1);
        }
        rootChange('answers', { ...answers, variants });
      }
    }
  }, [answers]);

  return (
    <div className={s.AnswerType5}>
      <div className={s.text}>
        {formatMessage('changeInput(___)')}
      </div>
      <Field
        name="answers.value"
        placeholder={formatMessage('changeText')}
        component={InputField}
        validate={[required()]}
      />
      <div className={s.text}>{formatMessage('changeInputs')}</div>
      {answers.variants.map((v, index) => (
        <Field
          name={`answers.variants[${index}]`}
          placeholder={formatMessage('changeText')}
          component={InputField}
          validate={[required()]}
        />
      ))}
    </div>
  );
}

export default AnswerType5;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType5/AnswerType5.jsx